

    require('./lines/LinesSeries');
    require('./lines/LinesView');

    var echarts = require('../echarts');
    echarts.registerLayout(
        require('./lines/linesLayout')
    );
    echarts.registerVisual(
        require('./lines/linesVisual')
    );



//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/lines.js
// module id = 847
// module chunks = 0